import { ViewContainerRef, OutputEmitterRef } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import type { Type } from '@angular/core';

export enum StepActionType {
  NEXT = 'NEXT',
  PREV = 'PREV'
}

export interface JoyrideStepInstance {
  targetHeight: number;
  stepHeight: number;
  redrawStep(): void;
}

export interface JoyrideOptions {
  steps: Array<string>;
  startWith?: string;
  waitingTime?: number;
  stepDefaultPosition?: StepPosition;
  showCounter?: boolean;
  showPrevButton?: boolean;
  showCloseButton?: boolean;
  standalonePrevButton?: boolean;
  customTexts?: CustomTexts;
}

export interface StepCounter {
  step: number;
  total: number;
}

export class JoyrideScroll {
  scrollX: number;
  scrollY: number;
}

export interface CustomTexts{
  back?: string | Observable<string>;
  next?: string | Observable<string>;
  done?: string | Observable<string>;
  close?: string | Observable<string>;
}

export enum StepPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  RIGHT = 'right',
  LEFT = 'left'
}

export interface JoyrideStepInfo {
  stepNumber: number;
  name: string;
  actionType: StepActionType;
}

export class JoyrideError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, JoyrideError.prototype);
  }
}

export class JoyrideStepDoesNotExist extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, JoyrideStepDoesNotExist.prototype);
  }
}

export class JoyrideStepOutOfRange extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, JoyrideStepOutOfRange.prototype);
  }
}

export class JoyrideStep {
  name: string;
  position: string;
  title: ReplaySubject<string>;
  text: ReplaySubject<string>;
  customLabel: ReplaySubject<string>;
  iconSrc: string;
  nextClicked: OutputEmitterRef<void>;
  backCliked: OutputEmitterRef<void>;
  tourDone: OutputEmitterRef<void>;
  transformCssStyle: string;
  isElementOrAncestorFixed: boolean;
  usedAsCoachMark: boolean;
  doNotShowPrevButton: boolean;
  targetViewContainer: ViewContainerRef;
  stepInstance: JoyrideStepInstance;
  stepComponent: Type<JoyrideStepInstance>;

  constructor() {
    this.title = new ReplaySubject<string>();
    this.text = new ReplaySubject<string>();
    this.customLabel = new ReplaySubject<string>();
  }
}
